import UserManagementComponent from "../components/UserManagement";

function UserManagement() {
  return <UserManagementComponent />;
}

export default UserManagement;
